import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import {
  faArrowLeftLong,
  faCartShopping,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import Cart from "../Cart/cartPage";
import { EMenuActions } from "../store";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function Nav() {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const showCartModal = useSelector((state) => state.EMenu.showCartModal);
  const cartItems = useSelector((state) => state.EMenu.cartItems);
  const all_products = useSelector((state) => state.EMenu.all_products);
  // const products = useSelector((state) => state.EMenu.products);
  const searchedValue = useSelector((state) => state.EMenu.searchedValue);

  const handleOpenModal = () => dispatch(EMenuActions.setShowCartModal(true));
  const handleCloseSection = () => {
    dispatch(EMenuActions.setShowSection(false))
    dispatch(EMenuActions.setActiveGroup(null));
  };
  const handleChange = (e) => {
    const value = e.target.value;
    dispatch(EMenuActions.setSearch(true));
    dispatch(EMenuActions.setSearchValue(value));
    if (value.trim() === "") {
      dispatch(EMenuActions.setSearchResult(all_products));
      dispatch(EMenuActions.setSearch(false));
    } else {
      const filteredProducts = all_products.filter(
        (product) =>
          product.name.toLowerCase().includes(value.toLowerCase()) ||
          product.SellPrice1.includes(value.toLowerCase())
      );
      dispatch(EMenuActions.setSearchResult(filteredProducts));
    }
  };

  return (
    <>
      <div className="px-8 max-sm:px-3 p-1 max-sm:pt-2 flex flex-row gap-2 justify-between items-center border-b-2 border-light">
        <motion.div
          whileHover={{ scale: 1.04 }}
          transition={{ duration: 0.3 }}
          className="w-[10%] cursor-pointer"
          onClick={handleCloseSection}
        >
          <FontAwesomeIcon
            icon={faArrowLeftLong}
            size="xl"
            className="text-dark"
          />
        </motion.div>
        <div className="flex justify-between items-center bg-light/80 rounded max-sm:w-[75%] w-[75%] px-2">
          <FontAwesomeIcon
            icon={faMagnifyingGlass}
            className="w-[10%] text-primary"
          />
          <input
            onChange={handleChange}
            value={searchedValue}
            type="text"
            className="outline-none bg-light/0 w-[90%] p-1"
            placeholder="Search by Name, Price or Category."
          />
        </div>
        <div className="h-full">
          <button
            onClick={handleOpenModal}
            className="md:w-[10%] xl:w-[45%] max-sm:w-[95%] text-center relative p-0.5 mx-5 max-sm:mx-1 bg-primary/20 border-2 border-primary text-primary rounded-lg hover:bg-primary hover:text-white"
          >
            <FontAwesomeIcon icon={faCartShopping} size="sm" />
            {/* barge/cart items counter */}
            <div className="bg-secondary  h-6 w-6 absolute p-[1.5px] text-[#fff] text-sm rounded-full -top-1 -right-3">
              {cartItems.length}
            </div>
          </button>
        </div>
        {showCartModal === true ? <Cart /> : ""}
      </div>
    </>
  );
}
